import { alias, params, extend } from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';

import {
  arrayOf as arrayOfType,
  number as numberType,
  shape as shapeType,
  string as stringType,
  bool as boolType
} from '@thd-nucleus/data-sources/react/dataModel/prop-types';

const Promotion = shapeType({
  experienceTag: stringType(),
  subExperienceTag: stringType(),
  anchorItemList: arrayOfType(stringType()),
  itemList: arrayOfType(stringType()),
  reward: shapeType({
    tiers: arrayOfType(shapeType({
      minPurchaseAmount: numberType({ float: true }),
      minPurchaseQuantity: numberType({ float: true }),
      rewardPercent: numberType({ float: true }),
      rewardAmountPerOrder: numberType({ float: true }),
      rewardAmountPerItem: numberType({ float: true })
    }))
  })
});

const Fulfillment = params({ storeId: stringType() }).shape({
  fulfillmentOptions: arrayOfType(shapeType({
    fulfillable: boolType(),
    type: stringType(),
    services: arrayOfType(shapeType({
      type: stringType(),
      locations: arrayOfType(shapeType({
        isAnchor: boolType(),
        locationId: stringType(),
        inventory: shapeType({
          isOutOfStock: boolType(),
          quantity: numberType()
        })
      }))
    }))
  }))
});

const Identifiers = shapeType({
  brandName: stringType(),
  productLabel: stringType(),
  canonicalUrl: stringType()
});

const Media = shapeType({
  image: shapeType({
    url: stringType()
  }).client(),
  images: arrayOfType(shapeType({
    url: stringType(),
    sizes: arrayOfType(stringType()),
    type: stringType(),
    subType: stringType()
  }))
});

const ProductModel = extend({
  itemId: stringType(),
  fulfillment: Fulfillment,
  identifiers: Identifiers,
  media: Media,
  pricing: params({ storeId: stringType() }).shape({
    value: numberType({ float: true })
  }),
  details: shapeType({
    description: stringType(),
    descriptiveAttributes: arrayOfType(shapeType({
      value: stringType()
    }))
  }),
  reviews: shapeType({
    ratingsReviews: shapeType({
      averageRating: stringType(),
      totalReviews: stringType()
    })
  })
}, ProductPod.dataModel.product);

export const dataModel = extend({
  clientOnlyProduct: alias('product').params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    pricing: params({ storeId: stringType().isRequired() }).shape({
      alternate: shapeType({
        bulk: shapeType({
          value: numberType({ float: true })
        })
      }),
      value: numberType({ float: true }),
      promotion: Promotion
    }),
    fulfillment: Fulfillment,
    media: Media
  }),
  discountedMultipleItemId: alias('products').params({
    itemIds: arrayOfType(stringType().isRequired()).isRequired()
  }).shape(ProductModel)
});
